import { useState, useCallback } from "react";
import { followUser, unfollowUser } from "../APIs/followApi";
import { trackEvent } from "../utils/analytics";

const useFollow = (profileId, initialFollowing = false) => {
  const [isFollowing, setIsFollowing] = useState(initialFollowing);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggleFollow = useCallback(async () => {
    if (loading || !profileId) return;

    // Optimistic update
    const prev = isFollowing;
    setIsFollowing(!prev);
    setLoading(true);
    setError(null);

    try {
      if (prev) {
        await unfollowUser(profileId);
      } else {
        await followUser(profileId);
        trackEvent('follow_action', { metadata: { profile_id: profileId } });
      }
    } catch (err) {
      // Rollback on error
      console.error("Follow toggle failed:", err);
      setIsFollowing(prev);
      setError("Action failed. Try again.");
    } finally {
      setLoading(false);
    }
  }, [profileId, isFollowing, loading]);

  return { isFollowing, loading, error, toggleFollow };
};

export default useFollow;